'use client';

import { memo } from 'react';
import { GlowSkeleton } from '@headless-workspace/glow-ds';
import { ComponentMemo } from '@headless-workspace/typings';

export const SearchBrandsSkeleton: ComponentMemo = memo(() => {
    return (
        <>
            <GlowSkeleton width={'90%'} height={'2rem'} containerClassName={'w-full'} />
            <GlowSkeleton width={'90%'} height={'2rem'} containerClassName={'w-full'} />
        </>
    );
});

SearchBrandsSkeleton.displayName = 'SearchBrandsSkeleton';
